import React, { Component } from 'react'
import styled from 'styled-components'
import media from '../../styles/media'

//Components
import CustomModal from '../container/modal/modal'
import StepName from './steps/StepName'
import StepClientNumber from './steps/StepClientNumber'
import StepContact from './steps/StepContact'
import StepSalesChannel from './steps/StepSalesChannel'
import StepThanks from './steps/StepThanks'

const Container = styled.div`
  margin: 0;
  ${media.md`
    margin: 120px;
  `};
`

function ContactUs({
  isOpen,
  currentStep,
  nextStep,
  toggleContact,
  name,
  channel,
  lopd,
  primaryContact,
  updatePrimaryContact,
  secondaryContact,
  updateSecondaryContact,
  clientNumber,
  updateJob,
  updateName,
  updateRUC,
  updateChannel,
  updateLopd,
  updateClientNumber,
  onFormSubmit,
  ruc
}) {
  return (
    <CustomModal isOpen={isOpen}>
      <Container>
        <StepName
          name={name}
          ruc={ruc}
          nextStep={nextStep}
          updateName={updateName}
          updateRUC={updateRUC}
          currentStep={currentStep}
        />
        <StepClientNumber
          clientNumber={clientNumber}
          nextStep={nextStep}
          currentStep={currentStep}
          updateClientNumber={updateClientNumber}
        />
        <StepContact
          secondaryContact={secondaryContact}
          primaryContact={primaryContact}
          updatePrimaryContact={updatePrimaryContact}
          updateSecondaryContact={updateSecondaryContact}
          nextStep={nextStep}
          updateJob={updateJob}
          currentStep={currentStep}
        />
        <StepSalesChannel
          channel={channel}
          onFormSubmit={onFormSubmit}
          nextStep={nextStep}
          updateChannel={updateChannel}
          updateLopd={updateLopd}
          currentStep={currentStep}
          lopd={lopd}
        />
        <StepThanks
          name={name}
          isOpen={isOpen}
          toggleContact={toggleContact}
          currentStep={currentStep}
        />
      </Container>
    </CustomModal>
  )
}

export default ContactUs



// WEBPACK FOOTER //
// ./src/components/contactus/contactus.js